import {
  AccountServiceProxy,
  BusinessServiceProxy,
  CustomerServiceProxy,
  IdentityServiceProxy,
  MobileBusinessProfileDto,
  MobileCustomerProfileDto,
  MobilePartnersDto,
  MobileReservedTimeDto,
  MobileServiceProxy,
  PasswordlessAuthenticateModel,
  PasswordlessAuthenticateResultModel,
  PasswordlessLoginProviderType,
  SendPasswordlessLoginCodeInput,
  TokenAuthServiceProxy,
  VerifyPasswordlessLoginCodeInput,
} from "services/shared/service-proxies/service-proxies";
import { AppConsts } from "../core/AppConsts";
import { AxiosConfigure } from "../core/AxiosConfigure";
import { StoreService } from "../services/store-service";


export class BusinessService {
  private _businessServiceProxy: BusinessServiceProxy;
  private _identityServiceProxy: IdentityServiceProxy;
  private _tokenAuthServiceProxy: TokenAuthServiceProxy;
  private _mobileServiceProxy: MobileServiceProxy; 
  private _customerServiceProxy: CustomerServiceProxy;
  private _accountServiceProxy: AccountServiceProxy;

  constructor() {
    this._businessServiceProxy = new BusinessServiceProxy(
      AppConsts.appBaseUrl,
      AxiosConfigure.getInstance()
    );
    this._mobileServiceProxy = new MobileServiceProxy(
      AppConsts.appBaseUrl,
      AxiosConfigure.getInstance()
    );
    this._identityServiceProxy = new IdentityServiceProxy(
      AppConsts.appBaseUrl,
      AxiosConfigure.getInstance()
    );
    this._tokenAuthServiceProxy = new TokenAuthServiceProxy(
      AppConsts.appBaseUrl,
      AxiosConfigure.getInstance()
    );
    this._customerServiceProxy = new CustomerServiceProxy(
      AppConsts.appBaseUrl,
      AxiosConfigure.getInstance()
    );
    this._accountServiceProxy = new AccountServiceProxy(
      AppConsts.appBaseUrl,
      AxiosConfigure.getInstance()
    );
  }

  /**
   * ✅ دریافت پروفایل اختصاصی کاربر
   * @returns اطلاعات پروفایل کاربر
   */
  getUserProfile(): Promise<MobileCustomerProfileDto> {
    return this._mobileServiceProxy
      .customerGet()
      .then((profile) => {
        StoreService.SetData("user-profile", profile); // ذخیره در localStorage
        return profile;
      })
      .catch((error) => {
        console.error("❌ خطا در دریافت پروفایل کاربر:", error);
        throw error;
      });
  }

  /**
   * دریافت پروفایل بر اساس نام
   * @param name نام پروفایل
   * @returns داده‌های پروفایل
   */
  getProfile(name: string): Promise<MobileBusinessProfileDto> {
    return this._businessServiceProxy.profile(name);
  }

  getFile(fileId: any, accessKey: any): Promise<string> {
    return this._businessServiceProxy.picture(fileId, accessKey);
  }

  /**
   * دریافت لیست شرکا
   * @param cancelToken توکن لغو درخواست
   * @returns لیست شرکا
   */
  getPartners(cancelToken?: any): Promise<MobilePartnersDto[]> {
    const partners = StoreService.GetData("partners");
    if (partners == null) {
      return this._businessServiceProxy.partners(cancelToken);
    }
    return Promise.resolve(partners as MobilePartnersDto[]);
  }

  getPartner(partnerId: number): Promise<MobilePartnersDto | undefined> {
    return this.getPartners().then((result) => {
      return result.find((value) => value.id === partnerId);
    });
  }

  /**
   * دریافت زمان‌های رزروشده
   * @param cancelToken توکن لغو درخواست
   * @returns لیست زمان‌های رزروشده
   */
  getReservedTimes(cancelToken?: any): Promise<MobileReservedTimeDto[]> {
    return this._businessServiceProxy.reservedTimes(cancelToken);
  }

  /**
   * دریافت اطلاعات اصلی
   * @param cancelToken توکن لغو درخواست
   * @returns void
   */
  getMain(cancelToken?: any): Promise<void> {
    return this._businessServiceProxy.main(cancelToken);
  }

  /**
   * دریافت تصویر با شناسه و توکن دسترسی
   * @param id شناسه تصویر
   * @param accessToken توکن دسترسی
   * @returns تصویر به صورت Base64
   */
  getPicture(id: string, accessToken: string): Promise<string> {
    return this._businessServiceProxy.picture(id, accessToken);
  }

  sendPasswordlessLoginCode(mobile: string): Promise<void> {
    // TODO: check mobile regex pattern
    if (!mobile) {
      return Promise.reject(new Error("Mobile number and token are required."));
    }
    return this._accountServiceProxy.sendPasswordlessLoginCode(
      new SendPasswordlessLoginCodeInput({
        providerValue: mobile,
        providerType: PasswordlessLoginProviderType.Sms,
      })
    );
  }

  VerifyPasswordlessLoginCode(
    mobile: string,
    code: string,
    token: string
  ): Promise<PasswordlessAuthenticateResultModel> {
    if (!code) {
      return Promise.reject(new Error(""));
    }
    if (!mobile) {
      return Promise.reject(new Error(""));
    }
    return this._accountServiceProxy
      .verifyPasswordlessLoginCode(
        new VerifyPasswordlessLoginCodeInput({
          code: code,
          providerValue: mobile,
        })
      )
      .then((result) => {
        return this._tokenAuthServiceProxy.passwordlessAuthenticate(
          new PasswordlessAuthenticateModel({
            providerValue: mobile,
            verificationCode: code,
            captchaResponse: token,
            provider: "sms",
            singleSignIn: false,
            returnUrl: "",
          })
        );
      });
  }

  // verifyOtp(otp: number, accessToken: string): Promise<string> {
  //     return this._identityServiceProxy.verifyOtp(otp, accessToken);
  // }
  //
  // sendOtp(mobile: string, accessToken: string): Promise<any> {
  //     return this._identityServiceProxy.sendOtp(mobile, accessToken);
  // }
  //
  // authenticateMobile(mobile: string, token: string): Promise<AuthenticateResultModel> {
  //     return this._tokenAuthServiceProxy.authenticate(new AuthenticateModel())
  // }
}
